import { Resources } from 'constants/resources';

import { useApiContext } from 'context/apiContext';
import { useProviderAccountsAccess } from 'pages/Finance/ProviderAccounts/hooks/useProviderAccountsAccess';
import { useGetList, useRecordContext } from 'react-admin';
import { SelectInput } from 'shared/react-admin/Inputs';
import { ReferenceInput } from 'shared/react-admin/ReferenceInputs';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { WorkTeam } from 'types/embedded/workTeam';

export const ProviderAccountsWorkTeamInput: React.FC = () => {
  const { user } = useApiContext();
  const { isFinanceLeadWithProviderAccess } = useProviderAccountsAccess();
  const record = useRecordContext<ProviderAccount>();

  const isManagedWorkTeamRequired = !record && isFinanceLeadWithProviderAccess;

  const { data: workTeams } = useGetList<WorkTeam>(
    Resources.WorkTeams,
    {
      filter: { manager: user.id },
      pagination: { page: 1, perPage: 1 },
    },
    { enabled: isManagedWorkTeamRequired && !!user.id },
  );

  const managedWorkTeam = isManagedWorkTeamRequired ? workTeams?.[0] : undefined;

  if (managedWorkTeam) {
    return (
      <SelectInput
        choices={[managedWorkTeam]}
        defaultValue={managedWorkTeam.id}
        fullWidth
        label="Рабочая группа"
        optionText="name"
        readOnly
        source="workTeam"
        variant="outlined"
      />
    );
  }

  return (
    <ReferenceInput disableReferenceFilter reference={Resources.WorkTeams} source="workTeam">
      <SelectInput fullWidth label="Рабочая группа" optionText="name" variant="outlined" />
    </ReferenceInput>
  );
};
